module.exports = __webpack_public_path__ + "static/media/card_bg_12.61f8eaba.png";